/* eslint-disable react/display-name */
import React from 'react';
import axios from 'helpers/axios';

import { DataTable, DataTableCell } from 'ui/components/shared';
import { Text, Badge } from '../styled';
import { useToasts } from 'hooks';
import { lastDayOfPreviousMonth, formatDate } from 'helpers/date';

export const ReportsByCategory = ({
  company,
  customer,
  date = lastDayOfPreviousMonth(),
  onSortChange,
}) => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [sort, setSort] = React.useState({ column: '', order: '' });
  const { errorToast } = useToasts();
  const columns = [
    {
      name: 'Category name',
      selector: 'category.name',
      minWidth: '250px',
      sortable: true,
      grow: 2,
      cell: (row) => {
        const { category } = row;
        return (
          <DataTableCell centered>
            <Text>{category?.name}</Text>
            {category?.archived && <Badge ml="xs">Archived</Badge>}
          </DataTableCell>
        );
      },
    },
    {
      name: 'Total Monitors',
      selector: 'jobs.total',
      minWidth: '100px',
      sortable: true,
      compact: true,
      //center: true,
      style: { paddingLeft: '5px' },
    },
    {
      name: 'Success',
      selector: 'jobs.success',
      minWidth: 'auto',
      sortable: true,
      compact: true,
      right: true,
    },
    {
      name: 'Failed',
      selector: 'jobs.failed',
      minWidth: 'auto',
      sortable: true,
      compact: true,
      right: true,
    },
    {
      name: 'Warning',
      selector: 'jobs.warning',
      minWidth: 'auto',
      sortable: true,
      compact: true,
      right: true,
    },
    {
      name: 'Late',
      selector: 'jobs.late',
      minWidth: 'auto',
      sortable: true,
      compact: true,
      right: true,
    },
    {
      name: 'Uninitialized',
      selector: 'jobs.unknown',
      minWidth: '120px',
      sortable: true,
      //compact: true,
      right: true,
    },
  ];

  const fetchReports = async () => {
    setLoading(true);

    try {
      const formattedDate = formatDate(date);
      const response = await axios.get(
        `/reports/byCategory/${company?.id}/${customer?.id}/?$top=-1&$orderby=${sort.column}&$order=${sort.order}&$date=${formattedDate}`
      );

      if (response.status === 200) {
        setData(response.data.value);
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Fetch Reports.' });
    }

    setLoading(false);
  };

  const handleSort = async (column, sortDirection) => {
    setLoading(true);

    const sortColumn = column?.selector || '';
    const sortOrder = sortColumn ? sortDirection : '';
    const sortData = { column: sortColumn, order: sortOrder };
    setSort(sortData);
    if (onSortChange) {
      onSortChange(customer, sortData);
    }

    try {
      const formattedDate = formatDate(date);
      const response = await axios.get(
        `/reports/byCategory/${company?.id}/${customer?.id}/?$top=-1&$orderby=${sortColumn}&$order=${sortOrder}&$date=${formattedDate}`
      );

      if (response.status === 200) {
        setData(response.data.value);
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Sort Reports.' });
    }

    setLoading(false);
  };

  React.useEffect(() => {
    fetchReports(1);
  }, []);

  return (
    <>
      <DataTable
        variant="greyed"
        columns={columns}
        data={data}
        progressPending={loading}
        onSort={handleSort}
        subHeader={false}
        pagination={false}
        stickyHeader={false}
        rowHeight="42px"
        noHeader
        noPadding
      />
    </>
  );
};
